import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import {
  closeModalSafely,
  handleSubmit,
} from './edit-menu-entry-category.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  setEditMenuEntryCategoryModalData,
  setIsEditMenuEntryCategoryModalOpen,
} from '../../../../redux/modal/modal.actions';
import {
  fetchItemCategories,
  fetchMenuEntries,
} from '../../../../redux/store/store.actions';
import {
  extractIds,
  getLocalizedName,
  isAdminMode as _isAdminMode,
} from '../../../../utility/util/util.service';
import InfoCategoryField from '../../form/fields/InfoCategoryField';
import DropdownField from '../../form/fields/DropdownField';
import { Alert } from 'reactstrap';

const EditMenuEntryCategoryModal = ({
  itemCategories,
  store,
  me,

  isOpen,
  data,
  setIsEditMenuEntryCategoryModalOpen,
  fetchMenuEntries,
}) => {
  const isAdminMode = _isAdminMode(me, store?.slug);
  const intl = useIntl();
  const [object, setObject] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);
  const { item, category, info, onSuccess } = data || {};

  const closeModal = () => setIsEditMenuEntryCategoryModalOpen(false);

  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);

  const _handleSubmit = (_, values) => {
    setIsSubmitting(true);
    handleSubmit(values, object).then(async () => {
      setIsSubmitting(false);
      closeModal();

      await fetchItemCategories(store.menu.id, isAdminMode);
      await fetchMenuEntries(store.menu.id, isAdminMode);
    });
  };

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      onOpen={() => setObject(item || category || info)}
      onClose={() => setObject(null)}
      title={intl.formatMessage({ id: 'editMenuEntryCategory' })}
      footer={
        <SaveSubmitButton
          className="w-100"
          disabled={isSubmitting}
          isSubmitting={isSubmitting}
          onClick={() => formRef?.current.handleSubmit()}
        />
      }
    >
      <div className="px-1">
        <AvForm
          ref={formRef}
          onValidSubmit={_handleSubmit}
          disabled={isSubmitting}
          data-testid="categorySelection"
        >
          <Alert className="mb-2" color="info">
            <FormattedMessage
              id="chooseCategoryItemLabel"
              values={{
                name: getLocalizedName(
                  object?.type === 'FoodItem' ? object.data[0] : object,
                  intl.locale,
                ),
              }}
            />
          </Alert>
          <DropdownField
            isMulti={object?.type === 'FoodItem'}
            isClearable={true}
            values={
              object &&
              (object?.type === 'FoodItem'
                ? extractIds(object.categories)
                : object?.type === 'InfoMenuEntry'
                ? object.category?.id
                : object?.type === 'ItemCategory' && object.parent?.id)
            }
            emptyValue={null}
            options={itemCategories?.filter(
              ({ id, parent }) =>
                // avoid putting itself as parent and avoid circular parents
                id !== object?.id && parent?.id !== object?.id,
            )}
            getOptionLabel={(category) =>
              getLocalizedName(category, intl.locale)
            }
            getOptionValue={(item) => item?.id}
            propertyName={
              object?.type === 'FoodItem'
                ? 'categoryIds'
                : object?.type === 'InfoMenuEntry'
                ? 'categoryId'
                : 'parentId' // ItemCategory
            }
            labelMessageId="selectCategoriesLabel"
          />
        </AvForm>
      </div>
    </ModalSheet>
  );
};

EditMenuEntryCategoryModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isEditMenuEntryCategoryModalOpen,
  data: state.modals.editMenuEntryCategoryModalData,
  itemCategories: state.store.itemCategories,
  store: state.store.store,
  me: state.me.me,
});

export default connect(mapStateToProps, {
  setIsEditMenuEntryCategoryModalOpen,
  setEditMenuEntryCategoryModalData,
  fetchMenuEntries,
})(EditMenuEntryCategoryModal);
